import { render, staticRenderFns } from "./TrainingBlock.vue?vue&type=template&id=729fe59e&"
import script from "./TrainingBlock.vue?vue&type=script&lang=js&"
export * from "./TrainingBlock.vue?vue&type=script&lang=js&"
import style0 from "./TrainingBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports